<style lang="less" scoped>
	/*@import "../../style/common.less";*/
	@import "../../style/color.less";
	@import "../../style/button.css";
	/*@import "../../style/greenStyle.less";*/
	/*@import "../../style/custom.less";*/
	/*@import "../../style/components.less";*/
	/*@import "../../style/uniform.default.min.less";*/

	.flex-1 {
		flex: 1;
	}
	.flex-2 {
		flex: 2;
	}

	.min-320 {
		min-width: 320px;
	}

	.min-540 {
		min-width: 540px;
	}
	.min-220 {
		min-width: 220px;
	}

	.inline-block {
		display: inline-block;
	}

	.query-div-select {
		width: 150px;
	}
	.label-control {
		display: inline-block;
		font-size: 14px;
		font-weight: 700;
		color: yellowgreen;
	}
	/*.el-table {
		background: linear-gradient(to right, #092a9c, #0c5692) !important ;
	}*/
	.form-control {
		background-color: white !important;
	}
	span.query-title-span {
		display: inline-block;
		width: 90px;
		font-size: 14px;
		font-weight: 700;
		text-align: right;
		margin-right: 20px;
		color: black;
	}
	span.query-title-span2 {
		display: inline-block;
		width: 90px;
		font-size: 14px;
		font-weight: 700;
		text-align: right;
		margin-right: 20px;
		color: red;
	}
	span.query-title-line {
		display: inline-block;
		font-size: 14px;
		font-weight: 700;
		text-align: center;
		width: 30px;
		color: yellowgreen;
	}
	/*.portlet.light{*/
	/*	background: linear-gradient(to right, #092a9c, #0c5692) !important ;*/
	/*}*/
	.query-div-input-date {
		width: 150px;
	}

	.query-div {
		// border: 1px solid #ddd;
		padding: 16px 0;
		border-radius: 4px;
	}

	.margin-left-8 {
		margin-left: 8px;
	}

	.draw-enter-active, .draw-leave-active {
		transition: all 1s ease;
	}

	.draw-enter, .draw-leave-to /* .fade-leave-active below version 2.1.8 */ {
		height: 0;
		overflow: hidden;
	}
	.uploadImg {
		width: 100%;
		height: 1.5rem;
		position: relative;
		input {
			width: 1.46rem;
			height: 100%;
			z-index: 1;
			opacity: 0;
			position: absolute;
			cursor: pointer;
		}
	}
</style>
<style lang="less">
	.input-class{
		.el-input__inner {
			width: 140px;
			height: 40px;
			border: 1px solid deepskyblue;
		}
	}
	.input-class2{
		.el-input__inner {
			width: 210px;
			height: 40px;
			border: 1px solid deepskyblue;
		}
	}
	.dialog-input-text .el-input__inner {
		//width: 75px;
		width: 100%;
		height: 40px;
		border: 1px solid deepskyblue;
		font-weight: bold;
	}
	//数字靠右
	.dialog-input-text2 .el-input__inner {
		//width: 75px;
		width: 100%;
		height: 40px;
		border: 1px solid deepskyblue;
		text-align: right;
	}
	.el-checkbox{
		.el-checkbox__inner{
			border: 1px solid deepskyblue;
		}
		/*.el-input__inner {
			width: 140px;
			height: 40px;
			border: 1px solid deepskyblue;
		}*/
	}
	.el-checkbox__inner{

	}
</style>

<template>
    <div class="iot-vue-container">
        <!-- 标题组件 -->
       <!-- <div class="vue-header">
            <div class="vue-header-title-div">
                <span class="vue-header-title" @click="init()">&nbsp;&nbsp;{{pageTitle}}</span>
            </div>
            <div class="vue-header-breadcrumb">
                &lt;!&ndash;<Breadcrumb>
                    <BreadcrumbItem :to="{name:sysCfg.mainPage}">首页</BreadcrumbItem>
                    <BreadcrumbItem>{{sysCfg.modules.null}}</BreadcrumbItem>
                    <BreadcrumbItem :to="{name:sysCfg.mCode.name_en}">{{sysCfg.mCode.name}}</BreadcrumbItem>
               </Breadcrumb>&ndash;&gt;
            </div>
        </div>-->
        <div class="vue-main">
            <!--查询条件 -->
            <div class="flex-div query-div">
              <!-- <div class="flex-1 min-320 margin-bottom-10">
                    <span class="query-title-span">代码类型</span>
                    <Select v-model="queryParam.codeType" class="query-div-select inline-block" placeholder="请选择" clearable>
                        <Option  v-for="option in xxxList" v-bind:value="option.label" :key="option.label">
                            {{option.value}}
                        </Option>
                    </Select>
               </div>-->
              <!-- <div class="flex-1 min-320 margin-bottom-10">
                    <span class="query-title-span">代码描述</span>
                    <Select v-model="queryParam.comment" class="query-div-select inline-block" placeholder="请选择" clearable>
                        <Option  v-for="option in xxxList" v-bind:value="option.label" :key="option.label">
                            {{option.value}}
                        </Option>
                    </Select>
               </div>-->
            </div>
            <!--操作功能区 -->
            <div class="actions-div  margin-bottom-10">
                <div class="btns-div margin-top-10">
					<Button type="primary" v-if="queryParam.value==null||queryParam.value==''" :disabled="true"  class="button button-glow button-rounded button-raised button-primary" @click="addRow"><i class="fa fa-plus"></i>新增</Button>
					<Button type="primary" v-else class="button button-glow button-rounded button-raised button-primary" @click="addRow"><i class="fa fa-plus"></i>新增</Button>
					<Button type="primary"  class="button button-glow button-rounded button-action" @click="toSave"><i class="fa fa-save"></i>保存</Button>
					<el-dialog title="保存" :visible.sync="dialogVisible1" width="30%">
						<span>保存选中数据？</span>
						<span slot="footer">
						<el-button @click="dialogVisible1 = false">取 消</el-button>
						<el-button type="primary" @click="checkedSave">确 定</el-button>
					  </span>
					</el-dialog>
					<span class="query-title-span2">代码类型</span>
					<el-select v-model="queryParam.value" placeholder="请选择"  filterable  clearable style="width: 150px" @change="commentChange">
						<el-option
							v-for="item in codeTypeList"
							:key="item.codeType"
							:label="item.comment"
							:value="item.codeType">
						</el-option>
					</el-select>
					<!--<Select v-model="queryParam.comment" class="query-div-select inline-block" placeholder="请选择" >
						<Option  v-for="option in codeTypeList" v-bind:value="option.codeType" :key="option.comment">
							{{option.comment}}
						</Option>
					</Select>-->
                </div>
                <!--<div class="pull-right">
                    &lt;!&ndash;搜索区 &ndash;&gt;
                    <Button type="primary" class="button button-glow button-rounded button-border button-action" v-loading.fullscreen.lock="fullscreenLoading" icon="ios-search" slot="append" @click="getList('query')">检索</Button>
                </div>-->
            </div>
            <!--操作功能区 -->
            <!--表格区-->
            <el-table :data="listData"  :row-style="rowStyle" :cell-style="tableRowStyle" :header-cell-style="tableHeaderColor" border row-key="id" @selection-change="handleSelectionChange"  ref="multipleTable" height="700px" >
				<el-table-column type="selection" align="center" width="40">
				</el-table-column>
                <el-table-column prop="comment" label="代码类型" min-width="100" align="left" >
                </el-table-column>
                <el-table-column prop="code" label="*代码" min-width="100" align="left" >
					<template slot-scope="scope" >
						<el-input dir="ltr" v-if="scope.row.id==''||scope.row.id==null" class="dialog-input-text" v-model="scope.row.code" @change="codeChange(scope.row)" maxlength="20" @focus="onFocus()">></el-input>
						<span  dir="ltr" v-else v-model="scope.row.code">{{scope.row.code}}</span>
					</template>
                </el-table-column>
                <el-table-column prop="codeNm" label="*代码名称" min-width="100" align="left">
					<template slot-scope="scope">
						<el-input  v-if="scope.row.codeType=='WEB_SERVICE'"  dir="ltr"class="dialog-input-text" v-model="scope.row.codeNm" @change="codeNmChange(scope.row)" maxlength="60" @focus="onFocus()">></el-input>
						<el-input  v-else class="dialog-input-text" dir="ltr" v-model="scope.row.codeNm" @change="codeNmChange(scope.row)" maxlength="40" @focus="onFocus()">></el-input>
					</template>
                </el-table-column>
                <el-table-column prop="delFlg" label="禁用" min-width="100" align="center">
					<template slot-scope="scope">
						<el-checkbox   v-if="scope.row.codeType=='WEB_SERVICE'" v-model="scope.row.delFlg" disabled></el-checkbox>
						<el-checkbox   v-else v-model="scope.row.delFlg"></el-checkbox>
					</template>
                </el-table-column>
            </el-table>
            <!--表格区-->
            <!--分页区 -->
           <!-- <el-pagination class="iot-pagination"   :current-page="pageParams.currentPage" :page-sizes="sysCfg.pageParams.opts"  @size-change="handleSizeChange" @current-change="handlePageChange" :page-size="pageParams.pageSize" :layout="sysCfg.pageParams.pageLayout" :total="pageParams.total">
            </el-pagination>-->
        </div>
    </div>
</template>
<script>
    import config from '@/config/config.js';
    import moment from 'moment';
	import { mapActions } from "vuex";
	import msgCfg from '@/config/msg.js';
    export default {
        data() {
            return {
                pageTitle: '代码维护',
                sysCfg: config,
                listData: [],
				codeTypeList: [],
                pageParams: {
                    currentPage: 1,
                    pageSize: 10,
                    total: 0,
                },
                queryParam: {
                    //pageNum: 0,
                    //pageSize: 10,
					codeType:'',
					comment:'',
					value:'',
                },
                searchVal: '',
                detailRouter: 'mCodeDetail',
                fullscreenLoading: false,
				dialogVisible1: false,
				multipleSelection: [],
				updateFlg:false,
            };
        },
        methods: {
			...mapActions("tab",["reflush"]),
            init() {
                // 数据初始化
                this.searchVal = '';
                //this.initLayui();
                this.codeTypeList=this.$sdnJob.getCodeTypeList(this);
                //console.log(this.codeTypeList,'this.codeTypeList')
                //this.getList('init');
				this.updateFlg=false;
            },
			onFocus() {
				this.updateFlg=true;
			},
			commentChange() {
				var _this = this;
				if (_this.queryParam.value!=''&&_this.queryParam.value!=null) {
					_this.getList();
				}
			},
			// 获取列表
			getList(val) {
				/*if (val !== undefined) {
					this.pageParams.currentPage = 1;
				}*/
				var _this = this;
				_this.initQueryParam();
				this.fullscreenLoading = true;
				_this.queryParam.codeType=_this.queryParam.value;
				_this.$httpUtil.ajaxGet(this, _this.$api.mCode.getList, _this.queryParam, function(response) {
					_this.listData = response.data.data;
					//console.log(response,'response1111');
					/*if (_this.listData.length === 0 && _this.pageParams.currentPage > 1) {
						_this.pageParams.currentPage--;
						_this.getList();
					} else {
						_this.pageParams.total = response.data.data.totalElements;
						_this.fullscreenLoading = false;
					}*/
				});
				_this.updateFlg=false;
			},
            // 初始化查询参数
            initQueryParam() {
                if (!this.$util.isEmpty(this.searchVal)) {
                    this.queryParam.mCodeName = this.searchVal;
                } else {
                    delete this.queryParam.mCodeName;
                }
                this.queryParam.pageNum = this.pageParams.currentPage - 1 >= 0 ? this.pageParams.currentPage - 1 : 0;
                this.queryParam.pageSize = this.pageParams.pageSize;
                this.queryParam.startDate= this.startDate;
                this.queryParam.endDate = this.endDate;
            },
			//保存选中结果
			handleSelectionChange(val) {
				/*var arr = [];
				val.forEach((val, index) => {
					this.multipleSelection.forEach((v, i) => {
						// id 是每一行的数据id
						if(val.id == v.id){
							arr.push(i)
						}
					})
				});*/
				this.multipleSelection = val;
				//console.log(this.multipleSelection,'multipleSelection');
			},
			rowStyle({row, rowIndex}){
				let arr = this.multipleSelection;
				if (arr!=null&&arr.length>0) {
					for(let i = 0; i < arr.length; i++){
						if( row.id == arr[i].id){
							return { "background-color": "rgba(0, 250, 154, 0.75)" };
						}
					}
				}
			},
            handlePageChange(val) {
                this.pageParams.currentPage = val;
                this.getList();
            },
            handleSizeChange(val) { // 条数变更回调
                this.pageParams.pageSize = val;
                this.getList();
            },
			// 代码更改触发事件
			codeChange(row) {
				let _this = this;
				let count=0;
				for(let i = 0; i < _this.listData.length; i++){
					if(row.code === _this.listData[i].code){
						count++;
					}
				}
				if (count>1) {
					//_this.$util.error('代码已存在');
					_this.$util.error(msgCfg.WEV6057W);
					return;
				}

			},
			// 代码名称更改触发事件
			codeNmChange(row) {
				let _this = this;
				let count=0;
				for(let i = 0; i < _this.listData.length; i++){
					if(row.codeNm == _this.listData[i].codeNm && row.comment !='WS配置'){
						count++;
					}
				};
				if (count>1) {
					//_this.$util.error('代码名称已存在');
					_this.$util.error(msgCfg.WEV6058W);
					return;
				}
			},

            //表格新增行
            addRow() {
				let _this = this;
				/*if (_this.queryParam.codeType==null||_this.queryParam.codeType=='') {
					_this.$util.error('请先选择代码类型');
					return;
				}*/
				let selected=this.multipleSelection;
				if (selected == null || selected == undefined || selected == '') {
					let list = {
						codeType: _this.queryParam.codeType,
						comment: _this.listData[0].comment,
						code: null,
						codeNm: null,
						delFlg: false,
					};
					this.listData.push(list);
					// 复制行设为选中
					this.$refs.multipleTable.toggleRowSelection(this.listData[this.listData.length-1], true);
				} else {
					if (selected.length > 1) {
						//_this.$util.error('只能选中一条数据复制新增');
						_this.$util.error(msgCfg.WEV6022W);
						return;
					} else {
						let selectedIndex=0;
						this.listData.forEach((val, index)=> {
							if (val==selected[0]) {
								selectedIndex=index;
								//console.log(selectedIndex,'selectedIndex1111');
							}
					    });
						let list = {
							id: null,
							codeType: selected[0].codeType,
							comment: selected[0].comment,
							code: selected[0].code,
							codeNm: selected[0].codeNm,
							delFlg: selected[0].delFlg,
						};
						this.listData.splice(selectedIndex+1, 0,JSON.parse(JSON.stringify(list)));
						// 原选中行设为取消选中
						this.$refs.multipleTable.toggleRowSelection(selected[0], false);
						// 复制行设为选中
						this.$refs.multipleTable.toggleRowSelection(this.listData[selectedIndex+1], true);
					}

				}

            },
            // 选中保存
            toSave() {
				//this.$store.commit("tab/DelCache","")
                let _this = this;
                let selected = this.multipleSelection;
                if (selected == null || selected == undefined || selected == '') {
                   // _this.$util.error('请选择要保存的数据');
                    _this.$util.error(msgCfg.WEV6024W);
                    return;
                }
				let delFlgCount=0;
                let oldDelFlgCount=0;
				for(let j = 0; j <selected.length; j++){
					if (selected[j].delFlg == false) {
						delFlgCount++;
					}
					if (selected[j].id!=null&&selected[j].oldDelFlg == false) {
						oldDelFlgCount++;
					}
				}
				//console.log(delFlgCount,'delFlgCount11111');
				for(let j = 0; j <_this.listData.length; j++){
					if (_this.listData[j].id!=null&&_this.listData[j].oldDelFlg == false) {
						delFlgCount++;
					}
				}
				//console.log(delFlgCount,'delFlgCount22222');
				delFlgCount=delFlgCount-oldDelFlgCount;
				if (delFlgCount==0) {
					//_this.$util.error('该代码类型必须保留一条数据可用');
					_this.$util.error(msgCfg.WEV6090W);
					return;
				}

				//console.log(delFlgCount,'delFlgCount333333');
                let codeCount=0;
                let codeNmCount=0;
				for(let i = 0; i <selected.length; i++){
					for(let j = 0; j <_this.listData.length; j++){
						if(selected[i].code == _this.listData[j].code){
							codeCount++;
						}
						if(selected[i].codeNm == _this.listData[j].codeNm && selected[i].comment != 'WS配置' ){
							codeNmCount++;
						}
					};
					if (selected[i].code==null||selected[i].code=='') {
						//_this.$util.error('代码不能为空');
						_this.$util.error(msgCfg.WEV6059W);
						return;
					}
					if (selected[i].codeNm==null||selected[i].codeNm=='') {
						//_this.$util.error('代码名称不能为空');
						_this.$util.error(msgCfg.WEV6060W);
						return;
					}
					if (codeCount>1) {
						//_this.$util.error('代码设置重复，请重新设置');
						_this.$util.error(msgCfg.WEV6061W);
						return;
					}
					if (codeNmCount>1) {
						//_this.$util.error('代码名称设置重复，请重新设置');
						_this.$util.error(msgCfg.WEV6062W);
						return;
					}
					codeCount=0;
					codeNmCount=0;
				};
				_this.dialogVisible1=true;
            },
			// 选中保存
			checkedSave() {
				//this.$store.commit("tab/DelCache","")
				let _this = this;
				let selected = this.multipleSelection;
				_this.$httpUtil.ajaxPut(this, _this.$api.mCode.checkedSave, selected, function (res) {
					if (res.data.data.status==200) {
						_this.$util.success(res.data.data.message);
						_this.getList();
					} else {
						_this.$util.error2(res.data.data.message);
					}
				});
				_this.dialogVisible1=false;
			},
/*            //设置表格行的样式
            tableRowStyle({row,column,rowIndex,columnIndex}){
                return "border: 1px solid black !important;font-size:13px;padding: 7px 0;"
            },
            //设置表头行的样式
            tableHeaderColor({row,column,rowIndex,columnIndex}){
				/!*if (columnIndex == 2 || columnIndex == 3) {
					return 'border: 1px solid black !important; font-wight:500;font-size:15px;text-align:center;background-color: #737077 !important;color:red;font-weight:bold !important;padding: 7px 0;';
				} else {
					return 'border: 1px solid black !important; font-wight:500;font-size:15px;text-align:center;background-color: #737077 !important;color:white;font-weight:bold !important;padding: 7px 0;';
				}*!/
				return 'border: 1px solid black !important; font-wight:500;font-size:15px;text-align:center;background-color: #737077 !important;color:white;font-weight:bold !important;padding: 7px 0;';

			},*/

			//设置表格行的样式
			tableRowStyle({row,column,rowIndex,columnIndex}){
				return "border: 1px solid black !important;color:black;font-size:16px;padding: 7px 0;"
			},
			//设置表头行的样式
			tableHeaderColor({row,column,rowIndex,columnIndex}){
				return 'border: 1px solid black !important; font-wight:500;font-size:15px;text-align:center;background-color: #CCCCCC !important;color:black;padding: 7px 0;'
			},
        },
        mounted() {
            this.init();

        },
        watch: {}
  };
</script>





// WEBPACK FOOTER //
// src/views/mCode/List.vue